import Axios from 'axios';

const API_URL =  process.env.API_URL + '/api/v3/data/products/brands';

class Brands {
  index() {
    return Axios.get(API_URL);
  }

  show(subcategory) {
    return Axios.get(API_URL + `/${subcategory}`);
  }
}

export default new Brands();



// WEBPACK FOOTER //
// ./src/api/brandsV3.js